import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { useCurrentTheme } from 'stores/utils/hooks/useCurrentTheme'
import { observer } from 'mobx-react'
import { memo, PropsWithChildren } from 'react'

const ThemeProvider = observer(({ children }: PropsWithChildren<unknown>) => {
  const { theme } = useCurrentTheme()

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline>{children}</CssBaseline>
    </MuiThemeProvider>
  )
})

export default memo(ThemeProvider)
